import { JSEncrypt } from "jsencrypt"

function decodeBase64(value: string): string {
  if (!value || typeof globalThis.atob !== "function") {
    return "";
  }

  return globalThis.atob(value);
}

const publicKey = decodeBase64(process.env.REACT_APP_RSA_PUBLIC_KEY || "");


export function encrypt(data: string): string {
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(publicKey);
  const encrypted = encrypt.encrypt(data);
  return encrypted
}
